<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success" style="margin-bottom: 0;"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          No：{{ formData.amzReplenishmentNo || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          {{ formData.amzPeriodTitle || '' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <el-tag
          size="mini"
          :type="
            formData.replenishmentStatus === 'N'
              ? 'primary'
              : formData.replenishmentStatus === 'D'
              ? 'danger'
              : formData.replenishmentStatus === 'P'
              ? 'warning'
              : formData.replenishmentStatus === 'Y'
              ? 'success'
              : formData.replenishmentStatus === 'S'
              ? 'logistics'
              : 'info'
          "
        >
          {{ formData.v_replenishmentStatus }}
        </el-tag>
        <el-divider direction="vertical"></el-divider>
        <el-tag
          v-if="formData.v_skuSalesChannel"
          size="mini"
          :type="
            formData.skuSalesChannel === 'F'
              ? 'success'
              : formData.skuSalesChannel === 'V'
              ? 'warning'
              : ''
          "
        >
          {{ formData.v_skuSalesChannel }}
        </el-tag>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyDate || '--' }}
        </span>
      </div>
    </div>

    <SkuTable
      :disabled="disabled"
      :amzReplenishmentCode="amzReplenishmentCode"
      :isVc="isVc"
    />
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import SkuTable from '../sku-table'
export default {
  mixins: [EditLoading],
  components: { SkuTable },
  props: {
    amzReplenishmentCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { formData: {} }
  },
  computed: {
    isVc() {
      const { skuSalesChannel } = this.formData
      return skuSalesChannel == 'V' ? 'Y' : 'N'
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzReplenishmentCode) return
      const res = await this.$api
        .ecomAmzReplenishmentDetailApi({
          amzReplenishmentCode: this.amzReplenishmentCode,
        })
        .catch(() => null)
      this.formData = res?.body || {}
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
::v-deep {
  .el-tag--logistics {
    background-color: #f9f0ff !important;
    border-color: #d3adf7 !important;
    color: #732ed1 !important;
  }
}
</style>
